<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import PageAlerts from "@/components/page-alerts";

export default {
  page: {
    title: "Fees SMS",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    PageAlerts,
  },
  data() {
    return {
      title: "Fees SMS",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Bulk SMS",
          href: "/bulk-sms",
        },
        {
          text: "Fees SMS",
          active: true,
        },
      ],
      data: {
        classes: [],
        course: "",
      },
      pageError: {
        classError: false,
      },
    };
  },

  computed: {
    ...mapGetters("classes", [
      "AllClasses",
      "AllStreams",
      "AllCourses",
      "CustomClasses",
    ]),
    ...mapGetters("bulksms", [
      "getFeesDefaultSms",
      "SaveStatus",
      "getFeesSMS",
      "getsmsBalance",
      "getSmsCalcFees",
      "SaveStatus",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchCourses: "classes/fetchCourses",
      FetchFeesDefaultSMS: "bulksms/fetchFeesDefaultSMS",
      FetchSmsBalance: "bulksms/fetchSmsBalance",
      SubmitFeesSMS: "bulksms/submitFeesSMS",
      FeesSmsCalc: "bulksms/feesSmsCalc",
      FetchCustomClasses: "classes/fetchCustomClasses",
    }),
    sendFeesSms() {
      this.resetError();
      if (this.data.classes.length > 0 && this.data.term != "") {
        this.SubmitFeesSMS(this.data);
      }
    },

    calculateSms() {
      this.data.term != "" ? this.FeesSmsCalc(this.data) : null;
    },
    fetchClasses() {
      const selectedCourse = { course: this.data.course };
      this.FetchCustomClasses(selectedCourse);
    },

    resetError() {
      this.data.classes.length
        ? (this.pageError.classError = false)
        : (this.pageError.classError = true);
    },
  },
  created() {
    this.FetchClasses();
    this.FetchCourses();
    this.FetchFeesDefaultSMS();
    this.FetchSmsBalance();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('send_fees_sms')
        )
      "
    >
      <div class="col-md-11 mx-auto">
        <div class="card row mx-flex">
          <div
            v-if="!SaveStatus && !getsmsBalance.deposit"
            class="my-5 col-md-10"
          >
            <PageAlerts
              title="CAUTION !"
              primaryMsg="Current you dont have SMS subscribed, Please subscribe to continue..."
              alertType="info"
            />
            <router-link
              to="/bulk-sms/settings"
              role="button"
              class="btn btn-sm btn-primary"
            >
              <i class="fa fa-circle-check"></i>
              Click to Subscribe
            </router-link>
          </div>
          <form v-else @submit.prevent="sendFeesSms">
            <div class="card-body col-md-12 mx-auto row">
              <div class="row col-md-6">
                <div class="form-group">
                  <label>Courses <small class="text-danger">*</small></label>
                  <div class="input-group mb-3">
                    <select
                      required
                      class="form-control"
                      v-model="data.course"
                      @change="resetError(), calculateSms(), fetchClasses()"
                    >
                      <option value="" disabled selected>Select Course</option>
                      <option
                        v-for="(course, index) in AllCourses"
                        :value="course.id"
                        :key="index"
                        >{{ course.name }}</option
                      >
                    </select>
                  </div>
                  <label>Levels <small class="text-danger">*</small></label>
                  <div class="input-group">
                    <multiselect
                      v-model="data.classes"
                      :height="300"
                      :options="CustomClasses ? CustomClasses : []"
                      :multiple="true"
                      :taggable="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      tag-placeholder="Add a Level"
                      placeholder="Search or add a Level"
                      label="name"
                      track-by="id"
                      :preselect-first="false"
                      @input="resetError(), calculateSms()"
                    >
                      <template slot="selection" slot-scope="{ values, isOpen }"
                        ><span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                          >{{ values.length }} Level(s) Selected</span
                        ></template
                      >
                    </multiselect>
                    <small v-if="pageError.classError" class="text-danger"
                      >Atleast Select a Level (Required)</small
                    >
                  </div>
                </div>
                <div class="form-group col-md-12 mt-3">
                  <div
                    class="alert alert-danger"
                    role="alert"
                    v-if="
                      getsmsBalance.deposit -
                        getsmsBalance.used -
                        getSmsCalcFees.total_std *
                          Math.ceil(getFeesDefaultSms.message.length / 159) <
                        0
                    "
                  >
                    <h5 class="card-title text-danger">
                      <i class="fa fa-exclamation" aria-hidden="true"></i>
                      Caution
                      <i class="fa fa-exclamation" aria-hidden="true"></i>
                    </h5>
                    <span>
                      You have Less SMS Balance, Please subscribe for more SMS
                      before you continue.
                      <br />
                      <br />
                      <router-link
                        to="/bulk-sms/settings"
                        role="button"
                        class="btn btn-sm btn-primary"
                      >
                        <i class="fa fa-circle-check"></i>
                        Click to Subscribe
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row col-md-6">
                <div class="col-lg-12 col-md-12">
                  <div class="text-primary mb-2">
                    <strong>Level(s) Selected</strong>
                  </div>
                  <div v-if="getSmsCalcFees.selected_classes">
                    <div
                      class="text-muted"
                      v-for="(sms, index) in getSmsCalcFees.selected_classes"
                      :key="index"
                    >
                      <p class="mb-1">
                        <i class="mdi mdi-circle-medium align-middle me-1"></i>
                        <strong>{{ sms.class_details.name }}</strong> |
                        <span>{{ sms.students }} Students</span>
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-muted">
                      <p class="mb-1">No Level(s) Selected</p>
                    </div>
                  </div>
                  <hr />
                  <div class="text-primary mb-2">
                    <strong>Total Students/Messages</strong>
                  </div>
                  <div class="text-muted">
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Total Students :</strong
                      ><span class="card-title">{{
                        getSmsCalcFees.selected_classes
                          ? getSmsCalcFees.total_std
                          : "0"
                      }}</span>
                    </p>
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Fees SMS Size: </strong>
                      <span class="card-title">
                        {{
                          getFeesDefaultSms.message
                            ? Math.ceil(
                                (getFeesDefaultSms.message.length + 80) / 159
                              )
                            : "0"
                        }}
                      </span>
                    </p>
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Total SMS/Messages: </strong>
                      <span class="card-title">
                        {{
                          getSmsCalcFees.selected_classes
                            ? getSmsCalcFees.total_std *
                              Math.ceil(
                                (getFeesDefaultSms.message.length + 60) / 159
                              )
                            : "0"
                        }}
                      </span>
                    </p>
                    <p class="mb-1 text-success">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Current SMS Balance: </strong>
                      <span class="card-title">{{
                        getsmsBalance.deposit
                          ? getsmsBalance.deposit - getsmsBalance.used
                          : "No balance found."
                      }}</span>
                    </p>
                  </div>

                  <div class="text-muted mt-2">
                    <div class="alert alert-primary" role="alert">
                      <strong>Default SMS</strong>
                      <p>
                        {{ getFeesDefaultSms.message }}
                        <strong
                          >[Student's Name, Course, Balances will be
                          here...]</strong
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <button
                    v-if="!getFeesDefaultSms.message"
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    <b-spinner
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                    Fetching SMS...
                  </button>
                  <button
                    v-else-if="SaveStatus"
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    <b-spinner
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                    Submiting...
                  </button>
                  <button
                    v-else-if="pageError.classError"
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    Send Message(s)
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                  </button>
                  <button
                    v-else-if="
                      getsmsBalance.deposit -
                        getsmsBalance.used -
                        getSmsCalcFees.total_std *
                          Math.ceil(getFeesDefaultSms.message.length / 159) <
                        0
                    "
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    Send Message(s)
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="btn btn-outline-primary btn-sm float-end"
                  >
                    Send Message(s)
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
